import { Model, fk, many, attr } from "redux-orm";
import { NaeSSchemaMap } from "../config/NaeSSchema";

class BankModel extends Model {
  static reducer(action, BankModel, session) {
    switch (action.type) {
      case "UPSERT_" + NaeSSchemaMap.Bank.schema:
        action.payload.forEach((payload) => {
          const dbData = BankModel.withId(payload.id);

          const upsertData = payload;
          if (dbData) {
            const keys = Object.keys(upsertData);
            let needChange = false;
            keys.map((key) => {
              if (
                JSON.stringify(upsertData[key]) !== JSON.stringify(dbData[key])
              ) {
                needChange = true;
              }
            });

            if (!needChange) {
              return;
            }
          }

          BankModel.upsert(payload);
        });
        break;
    }
    // Return value is ignored.
    return session.state;
  }

  toString() {
    return this.id;
  }
  // Declare any static or instance methods you need.
}
BankModel.modelName = "BankModel";

BankModel.fields = {
  id: attr(),
};

export default BankModel;